import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertTriangle } from 'lucide-react';
export function CountdownTimer() {
  // Set initial time to 25 minutes
  const [timeLeft, setTimeLeft] = useState(25 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="py-12 px-4 text-center" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-md mx-auto" data-id="element-78">
        <div className="flex items-center justify-center gap-2 mb-4 text-gold-400 font-semibold uppercase tracking-wider" data-id="element-79">
          <Clock className="w-5 h-5" data-id="element-80" />
          <span data-id="element-81">PRECIO DE LANZAMIENTO — CIERRA EN:</span>
        </div>

        <div className="flex justify-center items-center gap-2 md:gap-4 text-4xl md:text-5xl font-bold text-white mb-6 font-mono" data-id="element-82">
          <div className="bg-navy-800 border border-navy-600 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] shadow-inner" data-id="element-83">
            {formatTime(hours)}
            <span className="text-sm md:text-base text-blue-200/50 block font-sans font-normal mt-1" data-id="element-84">
              hs
            </span>
          </div>
          <span className="text-navy-600 pb-6" data-id="element-85">:</span>
          <div className="bg-navy-800 border border-navy-600 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] shadow-inner" data-id="element-86">
            {formatTime(minutes)}
            <span className="text-sm md:text-base text-blue-200/50 block font-sans font-normal mt-1" data-id="element-87">
              min
            </span>
          </div>
          <span className="text-navy-600 pb-6" data-id="element-88">:</span>
          <div className="bg-navy-800 border border-navy-600 rounded-lg p-3 md:p-4 min-w-[80px] md:min-w-[100px] shadow-inner" data-id="element-89">
            {formatTime(seconds)}
            <span className="text-sm md:text-base text-blue-200/50 block font-sans font-normal mt-1" data-id="element-90">
              seg
            </span>
          </div>
        </div>

        <div className="flex items-center justify-center gap-2 text-red-400 text-sm md:text-base font-medium bg-red-400/10 py-2 px-4 rounded-full inline-flex" data-id="element-91">
          <AlertTriangle className="w-4 h-4" data-id="element-92" />
          <span data-id="element-93">Después sube. No vuelve a este precio.</span>
        </div>
      </motion.div>
    </div>;
}